angular.module('bmsApp.settings')
	.factory('JobAlertDataSvc',
		function (
			CRUDSvc, JOB_ALERT_API) {
		return {
			read: function () {return CRUDSvc.get(JOB_ALERT_API.READ);},
			save: function (data) {return CRUDSvc.post(JOB_ALERT_API.SAVE, data);},

		};
	})
	.constant('JOB_ALERT_API', {
	READ: 'api/settings/job-alerts/read',
	SAVE: 'api/settings/job-alerts/save',
});